<template lang="pug">
v-card.dashboard-largest-clients-panel(outlined)
  v-card-title.dashboard-largest-clients-panel__title
    span Maiores clientes (Bases de dados) em GB
    .dashboard-largest-clients-panel__toggle(
      role="group",
      aria-label="Tipo de armazenamento"
    )
      button.dashboard-largest-clients-panel__toggle-button(
        type="button",
        :class="{ 'dashboard-largest-clients-panel__toggle-button--active': selectedStorage === 'fdb' }",
        :aria-pressed="selectedStorage === 'fdb'",
        @click="selectedStorage = 'fdb'"
      ) FDB
      button.dashboard-largest-clients-panel__toggle-button(
        type="button",
        :class="{ 'dashboard-largest-clients-panel__toggle-button--active': selectedStorage === 'log' }",
        :aria-pressed="selectedStorage === 'log'",
        @click="selectedStorage = 'log'"
      ) LOG
  v-card-text.dashboard-largest-clients-panel__body
    .dashboard-largest-clients-panel__shell
      ol.dashboard-largest-clients-panel__list(v-if="activeItems.length")
        li.dashboard-largest-clients-panel__item(
          v-for="(item, index) in activeItems",
          :key="`${selectedStorage}-${item.name}-${item.size}-${index}`"
        )
          span.dashboard-largest-clients-panel__rank {{ index + 1 }}
          span.dashboard-largest-clients-panel__name(:title="item.name") {{ item.name }}
          span.dashboard-largest-clients-panel__size {{ item.sizeLabel }}
      .dashboard-largest-clients-panel__empty(v-else)
        | Nenhum dado de armazenamento disponível.
</template>

<script>
export default {
  name: "LargestClientsPanel",
  props: {
    fdbItems: {
      type: Array,
      default: () => []
    },
    logItems: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedStorage: "fdb"
    };
  },
  computed: {
    activeItems() {
      return this.selectedStorage === "log" ? this.logItems : this.fdbItems;
    }
  }
};
</script>

<style scoped>
.dashboard-largest-clients-panel {
  width: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid #d9e2ef !important;
  border-radius: 18px 6px 18px 6px !important;
  box-shadow: 0 2px 8px rgba(15, 42, 77, 0.08) !important;
}

.dashboard-largest-clients-panel__title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 16px 16px 6px;
  color: #0a1f44;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.3;
}

.dashboard-largest-clients-panel__toggle {
  display: inline-flex;
  flex: 0 0 auto;
  padding: 2px;
  border: 1px solid #d9e2ef;
  border-radius: 999px;
  background-color: #f8fafc;
}

.dashboard-largest-clients-panel__toggle-button {
  min-width: 34px;
  padding: 5px 8px;
  border: 0;
  border-radius: 999px;
  background: transparent;
  color: #5f6b7a;
  cursor: pointer;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
}

.dashboard-largest-clients-panel__toggle-button--active {
  background-color: #3d82f6;
  color: white;
}

.dashboard-largest-clients-panel__body {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: auto;
  padding: 6px 14px 14px !important;
}

.dashboard-largest-clients-panel__shell {
  flex: 1 1 auto;
  min-height: 0;
  padding: 10px 12px;
  border: 1px solid #d9e3ef;
  border-radius: 10px;
  overflow-y: scroll;
  scrollbar-width: thin;
}

.dashboard-largest-clients-panel__list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.dashboard-largest-clients-panel__item {
  display: flex;
  align-items: center;
  min-width: 0;
  min-height: 36px;
  padding: 6px 0;
  gap: 8px;
  border-bottom: 1px solid #eef3f9;
}

.dashboard-largest-clients-panel__item:last-child {
  border-bottom: 0;
}

.dashboard-largest-clients-panel__rank {
  display: inline-flex;
  flex: 0 0 24px;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 999px;
  background-color: #f0f4f9;
  color: #5f6b7a;
  font-size: 11px;
  font-weight: 700;
}

.dashboard-largest-clients-panel__name {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  color: #31496b;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dashboard-largest-clients-panel__size {
  flex: 0 0 auto;
  color: #173256;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.3;
  white-space: nowrap;
}

.dashboard-largest-clients-panel__empty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 24px;
  color: #7d94b8;
  font-size: 13px;
  text-align: center;
}

@media (max-width: 1263px) {
  .dashboard-largest-clients-panel {
    height: auto;
    min-height: auto;
    max-height: none;
  }

  .dashboard-largest-clients-panel__body {
    height: auto;
  }

  .dashboard-largest-clients-panel__shell {
    max-height: 420px;
  }
}

@media (min-width: 1264px) {
  .dashboard-largest-clients-panel {
    height: 420px;
    min-height: 420px;
    max-height: 420px;
  }
}

@media (max-width: 959px) {
  .dashboard-largest-clients-panel__title {
    padding: 16px 14px 6px;
  }

  .dashboard-largest-clients-panel__body {
    padding: 6px 12px 12px !important;
  }
}
</style>
